<template>
  <div class="edit-partner">
    <PartnerForm mode="edit" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    PartnerForm: () => import(/* webpackChunkName: "PartnerForm" */ '@/views/Partner/PartnerForm')
  }
}
</script>
